import '../scss/flixx.scss';

// Load Bootstrap init
import {initHelpers} from "./components/helpers.js";
import {initScrollAndView} from "./components/scroll_and_view.js";
import {initBootstrap} from "./components/bootstrap.js";
import {initNavigation} from "./components/navigation.js";
import {initFlixxNews} from "./components/flixx_news.js";


$(document).ready(function () {
  initHelpers();
  initScrollAndView();
  initBootstrap();
  initNavigation();
  initFlixxNews();
});



